export const LEGAL_WHAT_ARE_COOKIES: string = `

## What are Cookies?

A cookie is a small amount of data (text file) that a website asks your browser to store on your device, in order to save information about you, for example, your language settings or login information. We use cookies and similar technologies such as local-storage, or pixels (collectively referred to here as "cookies") to store data as part of our platform as defined in our <button class="btn btn-link p-0" routerLink="privacy-policy">Privacy Policy</button>.
`;
